/**
 * Simulate Symfony's `asset` function.
 * Should match the `assets` function in services/app/legacy-public-src/js/twig/functions.js
 * Use only in the cases when it is not possible to import image by Webpack.
 * Webpack prefixes the images with the CDN URL automatically.
 *
 * @see https://github.com/symfony/asset/blob/6.1/Package.php#L48
 */
const asset = (assetSrc: string): string => {
    if (assetSrc.includes('://') || assetSrc.startsWith('//')) {
        return assetSrc;
    }

    return `${window.env.cdnFrontendAssetsUrl}${assetSrc}`;
};

export default asset;
